import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { invalidateTimeEntries } from './keys';
import { ITimeEntry, TimeEntryReviewAction } from './types';

interface IReviewTimeEntryVariables {
	id: string;
	action: TimeEntryReviewAction;
	comment?: string;
}

export const useReviewTimeEntryMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: unknown, variables: IReviewTimeEntryVariables) => void;
	onSuccess?: (data: ITimeEntry, variables: IReviewTimeEntryVariables) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id, action, comment }: IReviewTimeEntryVariables) =>
			userSession.webServiceHelper.callAsync<ITimeEntry>(`TimeEntry/${encodeURIComponent(id)}/${action}`, 'POST', {
				comment,
			}),
		onError,
		onSuccess,
		onSettled: () => invalidateTimeEntries(),
	});
};
